import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PasswordGate from "@/components/PasswordGate";
import DeckShell from "@/components/DeckShell";
import AdminApp from "@/admin/AdminApp";

function DeckApp() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem("instore_deck_session");
    if (raw) {
      try { setSession(JSON.parse(raw)); } catch { /* ignore */ }
    }
  }, []);

  const onAuthed = (s) => {
    localStorage.setItem("instore_deck_session", JSON.stringify(s));
    setSession(s);
  };
  const onLogout = () => {
    localStorage.removeItem("instore_deck_session");
    setSession(null);
  };

  return session ? (
    <DeckShell session={session} onLogout={onLogout} />
  ) : (
    <PasswordGate onSuccess={onAuthed} />
  );
}

function App() {
  return (
    <div className="App relative">
      <Toaster position="top-right" theme="light" duration={2500} toastOptions={{ style: { borderRadius: 0 } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<DeckApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
